import { render, staticRenderFns } from "./componente-loja.vue?vue&type=template&id=3f1a750d"
import script from "./componente-loja.vue?vue&type=script&lang=js"
export * from "./componente-loja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports